import script from "./SocketsTest.vue?vue&type=script&setup=true&lang=js"
export * from "./SocketsTest.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__